import {
  AutomationsIcon,
  DashboardIcon,
  GroupsIcon,
  LandingPageIcon,
  NewsletterIcon,
  NotificationsIcon,
  ReportsIcon,
  SmsIcon,
} from '../../assets/images/drawer/index';
import {
  CodeMenuIcon,
  DolarMenuIcon,
  SettingsMenuIcon,
  StarMenuIcon,
  GrafMenuIcon,
  GroupMenuIcon,
} from '../../assets/images/settings/index';
import { FaBinoculars } from 'react-icons/fa';
import { MdLogin, MdQrCode, MdVpnKey } from 'react-icons/md';
import { whatsappRoutes } from '../../screens/Whatsapp/Constant';
import { logout } from "../Api/PulseemReactAPI";
import { HiArrowLeft, HiArrowRight } from "react-icons/hi";
import { sitePrefix, isProdMode } from "../../config";
import { WhatsappIcon } from '../../assets/images/drawer/index';
import { PulseemFeatures } from '../../model/PulseemFields/Fields';
import { WhiteLabelObject } from '../../components/WhiteLabel/WhiteLabelMigrate';
import { UserRoles } from '../../Models/SubUser/SubUsers';
// export const rootDomain = !isProdMode ? 'http://localhost:58123' : '/Pulseem/';
export const rootDomain = '/Pulseem';

export const getSettingsItem = (
  t: (text: string) => null | VoidFunction = () => null,
  style: string = '',
  isAllowSwitchAccount: Boolean = false,
  title: string = "Settings",
  isRTL: Boolean = false,
  accountSettings: any,
  features: any = null,
  companyAdmin: boolean = false,
  userRoles: any = null
) => ({
  key: "settings",
  title: title,
  href: `${sitePrefix}AccountSettings`,
  options: [
    { key: 'accountSettings', title: t('master.RadMenuItemResource2.Text'), href: `${sitePrefix}AccountSettings`, iconSrc: SettingsMenuIcon, isShow: !accountSettings?.SubAccountSettings?.IsTokenAccount && userRoles === UserRoles.Admin },
    { key: 'billingSettings', title: t('master.linkAccountBilling.Text'), href: `${sitePrefix}BillingSettings`, iconSrc: DolarMenuIcon, isShow: companyAdmin && !accountSettings?.SubAccountSettings?.IsTokenAccount && userRoles === UserRoles.Admin },
    { key: 'affiliateManagement', title: t('master.affiliateManagement'), href: `${sitePrefix}AffiliateManagement`, iconSrc: DolarMenuIcon, isShow: features && features?.indexOf(PulseemFeatures.AFFILIATE) > -1 && !accountSettings?.SubAccountSettings?.IsTokenAccount && userRoles === UserRoles.Admin },
    { key: 'accountUsers', title: t('master.RadMenuItemResource3.Text'), href: `${sitePrefix}AccountUsers`, iconSrc: GroupMenuIcon, isShow: companyAdmin && !accountSettings?.SubAccountSettings?.IsTokenAccount && userRoles === UserRoles.Admin },
    { title: t('master.RadMenuItemResource4.Text'), href: `${rootDomain}/AccountUsersReport.aspx?fromreact=true`, iconSrc: GrafMenuIcon, isShow: companyAdmin && !accountSettings?.SubAccountSettings?.IsTokenAccount && userRoles === UserRoles.Admin },
    { title: t('master.RadMenuItemResource23.Text'), href: `${sitePrefix}AccountSettings/ExtraFields`, iconSrc: StarMenuIcon, isShow: true },
    //@ts-ignore
    { title: t('master.linkApiSettingsResource1.Text'), href: `${sitePrefix}ApiSettings`, iconSrc: CodeMenuIcon, isShow: userRoles.AllowSend && (!accountSettings?.SubAccountSettings?.IsTokenAccount && (WhiteLabelObject[accountSettings?.Account?.ReferrerID] === undefined || !accountSettings?.Account?.ReferrerID || accountSettings?.Account?.ReferrerID === 0)) ? true : false },
    { key: 'SiteTracking', title: t('master.siteTracking'), href: `${sitePrefix}SiteTracking`, iconSrc: FaBinoculars, isFaIcon: true, isShow: userRoles.AllowSend && !accountSettings?.SubAccountSettings?.IsTokenAccount },
    { key: 'Integrations', title: t('integrations.title'), href: `${sitePrefix}Integrations`, iconSrc: SettingsMenuIcon, isShow: !accountSettings?.SubAccountSettings?.IsTokenAccount && userRoles.AllowSend },
    { key: 'SubUsers', title: t('SubUsers.title'), href: `${sitePrefix}SubUsers`, iconSrc: SettingsMenuIcon, isShow: true },
    { key: 'ssoSettings', title: t('settings.sso.menuTitle'), href: `${sitePrefix}SsoSettings`, iconSrc: MdVpnKey, isFaIcon: true, isShow: !accountSettings?.SubAccountSettings?.IsTokenAccount && userRoles === UserRoles.Admin && !accountSettings?.SsoUsesMainAccountLogin },
    { key: 'authenticatorApp', title: t('settings.authenticatorApp.menuTitle'), href: `${sitePrefix}AuthenticatorApp`, iconSrc: MdQrCode, isFaIcon: true, isShow: !accountSettings?.SubAccountSettings?.IsTokenAccount },
    { key: 'mySso', title: t('settings.mySso.menuTitle'), href: `${sitePrefix}MySso`, iconSrc: MdLogin, isFaIcon: true, isShow: !accountSettings?.SubAccountSettings?.IsTokenAccount && !!accountSettings?.SsoMySsoAvailable },
    //@ts-ignore
    { key: 'Guides', title: t('common.UserGuides'), href: `https://site.pulseem.co.il/guides-2/`, iconSrc: SettingsMenuIcon, isShow: (!accountSettings?.SubAccountSettings?.IsTokenAccount && (WhiteLabelObject[accountSettings?.Account?.ReferrerID] === undefined || !accountSettings?.Account?.ReferrerID || accountSettings?.Account?.ReferrerID === 0)) ? true : false, openInNewWindow: true },
    { title: t("appBar.logout"), onClick: logout, iconSrc: isRTL ? HiArrowLeft : HiArrowRight, isFaIcon: true, isShow: true },
  ],
});


export const getRoutes = (
  t: (text: string) => null | VoidFunction = (par: string) => null,
  isClalAccount: Boolean | string = false,
  features: any = null,
  accountSettings: any = null,
  windowSize: string | number | null = null,
  isRTL: Boolean = false,
  userRoles: any = null,
  isPolandAccount: Boolean = false
) => [
    // smsOldVersion
    {
      key: "dashboard",
      title: t("dashboard.pageTitle"),
      iconUnicode: "\uF064",
      href: sitePrefix,
      isShow: windowSize && windowSize === "xs" ? true : false,
      icon: <img alt="Dashboard" src={DashboardIcon} />,
    },
    {
      key: "groups",
      title: t("appBar.groups.title"),
      iconUnicode: "\ue0d5",
      href: `${sitePrefix}groups`,
      isShow: true,
      iconName: 'MdPeople',
      options: [
        {
          key: "groupManagement",
          title: t("master.RadMenuItemResource6.Text"),
          href: `${sitePrefix}groups`,
          isShow: true,
        },
        {
          key: 'clientSearch',
          title: t("client.logPageHeaderResource1.search"),
          href: `${sitePrefix}ClientSearch`,
          isShow: !userRoles?.HideRecipients
        },
        {
          title: t("master.RadMenuItemResource37.Text"),
          href: `${rootDomain}/ClientAdvancedSearch.aspx?fromreact=true`,
          isShow: false,
        },
        {
          key: "dynamicGroups",
          title: t("master.RadMenuItemResourceDynamicGroups.Text"),
          href: `${sitePrefix}Groups/Dynamic`,
          isShow: !accountSettings?.SubAccountSettings?.IsTokenAccount,
        },
        {
          key: 'EditDynamicGroup',
          title: t("recipient.logPageHeaderResource1.Edit"),
          href: ``,
          isShow: false,
        },
        {
          key: 'fileUploads',
          title: t("master.RadMenuItemResourceFileUploads.Text"),
          href: `${sitePrefix}Groups/FileUploads`,
          isShow: true,
        },
        {
          key: 'downloadfiles',
          title: t('master.fileDownload'),
          href: `${sitePrefix}groups/Download`,
          isShow: true
        },
        {
          key: 'dataSources',
          title: t('DataSources.menuTitle'),
          href: `${sitePrefix}DataSources`,
          isShow: !!(features && features.indexOf(PulseemFeatures.DATA_SOURCES) > -1)
        },
        {
          // HIDDEN FROM THE SIDEBAR ON PURPOSE (PO decision) — Smart Send is a step, not a destination:
          // it is reached from the Data Sources header button, from any source row, from the campaign
          // row action, from the BEE editor, and from the mapping registry tab. SmartSendScreen itself
          // already declares currentPage="groups", so the app never treated this as its own place.
          //
          // isShow:false, NOT deletion. DefaultScreen.js:41-43 derives the browser <title> from THIS
          // record, matching on `key` alone and ignoring isShow — so the entry has to survive for
          // /SmartSend and /Campaigns/SmartSend/:id to keep their tab titles. Deleting it drops them to
          // a bare "מערכת פולסים" in the tab, in history and in every bookmark.
          //
          // Both routes stay registered in App.js — only the sidebar entry goes.
          key: 'smartSend',
          title: t('DataSources.send.title'),
          href: `${sitePrefix}SmartSend`,
          isShow: false
        },
        {
          // NOT gated on AllowSend, unlike smartSend above. SendSearch is a read-only report;
          // requiring send permission would hide it from the supervisors and support staff it exists
          // for. That stays true. It must stay identical to the route gate in App.js (P3.2).
          //
          // HideRecipients IS gated, and that is a different permission from AllowSend — no conflict
          // with the paragraph above. SendSearchController refuses the Search action outright with 405
          // for this permission ("It returns recipient PII"), so without this the entry was a dead menu
          // item: it opened a page on which every search came back empty with a permission error.
          // Same test as the `clientSearch` entry above, for the same reason.
          key: 'sendSearch',
          title: t('SendSearch.nav.sendSearch'),
          href: `${sitePrefix}SendSearch`,
          isShow: !!(features && features.indexOf(PulseemFeatures.DATA_SOURCES) > -1 && !userRoles?.HideRecipients)
        }
      ],
    },
    {
      key: "newsletter",
      title: t("master.newsletter"),
      pageTitle: t("campaigns.logPageHeaderResource1.Text"),
      iconUnicode: "\ue0a1",
      href: `${sitePrefix}Campaigns`,
      isShow: !accountSettings?.SubAccountSettings?.IsTokenAccount,
      iconName: 'MdMarkEmailRead',
      options: [
        {
          key: "newsletterInfo",
          title: t("master.RadMenuItemResource9b.Text"),
          href: `${sitePrefix}Campaigns/Create`,
          isShow: true,
        },
        {
          key: "newsletterManagment",
          title: t("master.RadMenuItemResource9.Text"),
          href: `${sitePrefix}Campaigns`,
          isShow: true,
        },
        {
          title: t("master.linkSendCampaignByResultResource1.Text"),
          href: `${rootDomain}/CampaignsByResults.aspx?fromreact=true`,
          isShow: false,
        },
        {
          title: t("master.RadMenuItemResource9a.Text"),
          href: `${rootDomain}/AutoSendPlans.aspx?fromreact=true`,
          isShow: true,
        },
        {
          title: 'A/B Test',
          href: `${rootDomain}/CampaignsAbTestings.aspx?fromreact=true`,
          isShow: !isPolandAccount,
        },
        // {
        //   title: t("master.RadMenuItemResource10.Text"),
        //   href: `${rootDomain}/CampaignTemplates.aspx?fromreact=true`,
        //   isShow: true,
        // },
        {
          title: t("master.newslatterBasicEditor"),
          href: `${rootDomain}/CampaignEdit.aspx?NewsLetterType=Basic&fromreact=true`,
          isShow: !isPolandAccount,
        },
        {
          key: "archiveManagement",
          title: t("master.campaignsArchive"),
          href: `${sitePrefix}Campaigns/Archive`,
          isShow: true,
        },
        {
          key: "newsletterSendSettings",
          title: t("campaigns.newsLetterSendSettings.title"),
          href: `${sitePrefix}Campaigns/SendSettings`,
          isShow: false
        },
        {
          key: 'ampRegistration',
          title: t('master.ampRegistration'),
          href: `${sitePrefix}Campaigns/AmpRegistration`,
          isShow: features?.indexOf(PulseemFeatures.BEE_AMP) > -1
        }
      ],
    },
    {
      key: "sms",
      title: "SMS",
      pageTitle: t("sms.PageResource1.Title"),
      iconUnicode: "\ue181",
      href: `${sitePrefix}SMSCampaigns`,
      isShow:
        features &&
        !features.error &&
        features !== null &&
        features.indexOf("7") > -1 &&
        !accountSettings?.SubAccountSettings?.IsTokenAccount,
      iconName: 'MdSms',
      options: [
        {
          key: "create",
          title: t("master.RadMenuItemResource101.Text"),
          href: `${sitePrefix}sms/create`,
          isShow: true,
        },
        {
          key: "smsManagment",
          title: t("master.RadMenuItemResource102.Text"),
          href: `${sitePrefix}SMSCampaigns`,
          isShow: true,
        },
        {
          title: t("master.chatbotSMS"),
          href: `${rootDomain}/SMSSmartResponses.aspx?fromreact=true`,
          isShow: true,
        },
        // {
        //   title: t("master.linkSMSResponsesReport.Text"),
        //   href: `${sitePrefix}reports/Inbound`,
        //   isShow: true,
        // },
        {
          title: t("master.NewMMSCampaign.Text"),
          href: `${rootDomain}/MmsCampaignEdit.aspx?fromreact=true`,
          isShow: features && features?.indexOf(PulseemFeatures.MMS) > -1,
        },
        {
          title: t("master.MmsCampaignMnage.Text"),
          href: `${sitePrefix}MmsCampaigns`,
          isShow: features && features?.indexOf(PulseemFeatures.MMS) > -1,
        }
      ],
    },
    {
      key: 'whatsapp',
      title: 'Whatsapp',
      pageTitle: t('whatsapp.Title'),
      iconName: 'IoLogoWhatsapp',
      href: whatsappRoutes.CAMPAIGN_MANAGEMENT,
      isShow: !accountSettings?.SubAccountSettings?.IsTokenAccount,
      // icon: <WhatsappIcon className='header-whatsapp-icon' />,
      options: [
        {
          key: 'create',
          title: t('whatsapp.NewWhatsappCampaign'),
          href: whatsappRoutes.CREATE_TEMPLATE,
          isShow: true,
        },
        {
          key: 'createWhatsappCampaign',
          title: t('whatsapp.SendWhatsappCampaign'),
          href: whatsappRoutes.CREATE_CAMPAIGN_PAGE1,
          isShow: true,
        },
        {
          key: 'templatemanagement',
          title: t('whatsapp.ManageWhatsappTemplate'),
          href: whatsappRoutes.TEMPLATE_MANAGEMENT,
          isShow: true,
        },
        {
          key: 'campaignmanagement',
          title: t('whatsapp.ManageWhatsappCampaign'),
          href: whatsappRoutes.CAMPAIGN_MANAGEMENT,
          isShow: true,
        },
        {
          key: 'chat',
          title: t('whatsapp.ChatWhatsapp'),
          href: whatsappRoutes.CHAT,
          isShow: userRoles?.AllowWhatsAppToAgent,
        },
        {
          key: 'onboarding',
          title: t('WhatsappOnBoarding.title'),
          href: whatsappRoutes.ONBOARDING,
          isShow: true,
        }
      ],
    },
    {
      key: "landingPages",
      title: t("master.RadItemLandingPagesMenu.Text"),
      pageTitle: t("landingPages.logPageHeaderResource1.Text"),
      iconUnicode: "\ue09d",
      href: `${sitePrefix}EditRegistrationPage`,
      isShow: true,
      iconName: 'FiFileText',
      options: [
        {
          key: "createLandingPage",
          title: t("master.RadMenuItemLandingPage.Text"),
          href: `${sitePrefix}LandingPages/Create`,
          isShow: true,
        },
        {
          title: t("master.RadMenuItemLandingManagement.Text"),
          href: `${sitePrefix}EditRegistrationPage`,
          isShow: true,
        },
        {
          title: t("master.FormTemplatesResource1.Text"),
          href: `${rootDomain}/FormTemplates.aspx?fromreact=true`,
          isShow: !accountSettings?.SubAccountSettings?.IsTokenAccount,
        },
        {
          key: 'CreateLandingPage',
          title: t("landingPages.createLandingPage"),
          href: ``,
          isShow: false,
        },
        {
          key: 'EditLandingPage',
          title: t("landingPages.editLandingPage"),
          href: ``,
          isShow: false,
        },
        {
          key: 'campaignEditor',
          title: t("landingPages.editLandingPage"),
          href: ``,
          isShow: false
        },
        {
          key: 'previewer',
          title: t("landingPages.editLandingPage"),
          href: ``,
          isShow: false,
        }
      ],
    },
    {
      key: "popups",
      title: t("landingPages.popups") || "Pop Ups",
      pageTitle: t("landingPages.popups") || "Pop Ups",
      iconUnicode: "\ue09d",
      href: `${sitePrefix}PopUpManagement`,
      isShow: features && features?.indexOf(PulseemFeatures.Popup) > -1,
      iconName: 'FaRegWindowRestore',
      options: [
        {
          key: "createPopup",
          title: t("landingPages.createPopup"),
          href: `${sitePrefix}Popups/Create`,
          isShow: true,
        },
        {
          key: "popupManagement",
          title: t("master.RadMenuItemPopupManagement.Text"),
          href: `${sitePrefix}PopUpManagement`,
          isShow: true,
        },
      ],
    },
    {
      key: "automations",
      title: t("master.Automations"),
      pageTitle: t("automations.logPageHeaderResource1.Text"),
      iconUnicode: "\ue087",
      href: `${sitePrefix}Automations`,
      isShow: !accountSettings?.SubAccountSettings?.IsTokenAccount,
      iconName: 'BiSitemap',
      options: [
        {
          title: t("master.createTemplate"),
          href: `${rootDomain}/CreateAutomations.aspx?fromreact=true&template=true&Culture=${isRTL ? 'he-IL' : 'en-US'}`,
          isShow: features && features?.indexOf(PulseemFeatures.AUTOMATION_TEMPLATE) > -1,
        },
        {
          title: t("master.manageTemplate"),
          href: `${rootDomain}/AutomationTemplates.aspx?fromreact=true&Culture=${isRTL ? 'he-IL' : 'en-US'}`,
          isShow: features && features?.indexOf(PulseemFeatures.AUTOMATION_TEMPLATE) > -1,
        },
        {
          key: 'create-automations',
          title: t("master.RadMenuItemCreateAutomationResource.Text"),
          href: `${sitePrefix}Automations/Create`,
          isShow: true,
        },
        {
          key: "automations",
          title: t("master.RadMenuItemManageAutomationResource.Text"),
          href: `${sitePrefix}Automations`,
          isShow: true,
        },
      ],
    },
    {
      key: "Integrations",
      title: t("integrations.hubTitle"),
      pageTitle: t("integrations.hubTitle"),
      href: `${sitePrefix}Integrations`,
      isShow: !accountSettings?.SubAccountSettings?.IsTokenAccount && userRoles?.AllowSend,
      iconName: 'MdOutlineDashboardCustomize',
    },
    {
      // CLAL CENTER — a TOP-LEVEL entry, on the `Integrations` pattern directly above (a live
      // top-level record with no `options` at all). It is deliberately NOT a child of `groups`:
      // that menu is Contacts/Groups — group management, client search, data sources — all of it
      // about recipients and sends. A content CMS for a public portal does not belong there, and
      // for a Clal editor this is the only screen they will ever open.
      //
      // ⚠️ `DefaultScreen.js:42` runs `route[0].options.filter(...)`, so a screen pointing at this
      // record MUST declare `currentPage="clalCenter"` with NO `subPage` — there are no `options`
      // here to filter. Working precedent: `Integrations.tsx`.
      //
      // Placing it between two existing top-level records touches no existing line.
      key: "clalCenter",
      title: t("ClalCenter.menuTitle"),
      pageTitle: t("ClalCenter.title"),
      href: `${sitePrefix}ClalCenter`,
      // Must stay identical to the route gate in App.js.
      isShow: !!(features && features.indexOf(PulseemFeatures.CLAL_CENTER) > -1),
      // Clal's own mark (SideMenu/ClalMarkIcon.tsx). This entry used to carry
      // MdOutlineDashboardCustomize — the SAME glyph as the Integrations record directly above,
      // its own neighbour in the rendered menu. A collapsed sidebar shows nothing BUT the icon,
      // so two adjacent rows sharing one were, at that width, the same row twice.
      iconName: 'ClalMark',
    },
    {
      key: "notifications",
      title: t("master.notifications"),
      pageTitle: t("notifications.notificationManagement"),
      iconUnicode: "\ue117",
      href: `${sitePrefix}Notifications`,
      isShow:
        features &&
        !features.error &&
        features !== null &&
        features.indexOf("35") > -1 &&
        !accountSettings?.SubAccountSettings?.IsTokenAccount,
      iconName: 'MdNotificationsActive',
      options: [
        {
          key: "createNotification",
          title: t("master.createNotification"),
          href: `${sitePrefix}Notification/create`,
          isShow: true,
        },
        {
          key: "notifications",
          title: t("master.manageNotifications"),
          href: `${sitePrefix}Notifications`,
          isShow: true,
        },
      ],
    },
    {
      key: "reports",
      title: t("master.RadMenuItemResource19.Text"),
      pageTitle: t("mainReport.logPageHeaderResource1.Text"),
      iconUnicode: "\ue049",
      href: `${sitePrefix}Reports/NewsletterReports`,
      isShow: !accountSettings?.SubAccountSettings?.IsTokenAccount,
      iconName: 'FiPieChart',
      options: [
        { title: t('master.clalCollage'), href: `${rootDomain}/ClalReport.aspx?fromreact=true`, isShow: (isClalAccount === 'true' || isClalAccount === true) },
        { key: "newsletterReport", title: t('master.RadMenuItemResource13.Text'), href: `${sitePrefix}reports/NewsletterReports`, isShow: true },
        { key: 'SmsReport', title: t('master.RadMenuItemResource24.Text'), href: `${sitePrefix}reports/SMSMainReport`, isShow: true },
        // { key: 'MmsReport', title: t('mmsreport.mmsReport'), href: `${sitePrefix}Reports/MMSMainReport`, isShow: true },
        { key: 'whatsappReports', title: t('whatsapp.ReportsWhatsapp'), href: whatsappRoutes.REPORTS, isShow: true },
        // { title: t('master.AbTestsReport.Text'), href: `${rootDomain}/AbTestsReport.aspx?fromreact=true`, isShow: true },
        { title: t('master.RadMenuItemResource15.Text'), href: `${rootDomain}/AccountReport.aspx?fromreact=true`, isShow: true },
        { title: t('master.RadMenuItemResource16.Text'), href: `${rootDomain}/CampaignComparison.aspx?fromreact=true`, isShow: false },
        { key: 'recipientReport', title: t('master.RadMenuItemResource18.Text'), href: `${sitePrefix}Reports/Recipient`, isShow: !userRoles?.HideRecipients },
        { title: t('master.RadMenuItemResource30.Text'), href: `${rootDomain}/EmailAutoReports.aspx?fromreact=true`, isShow: true },
        { title: t('master.locRemovedReason.Text'), href: `${rootDomain}/RemovedStats.aspx?fromreact=true`, isShow: true },
        { key: 'productsReport', title: t('report.ProductsReport.products'), href: `${sitePrefix}Reports/ProductsReport`, isShow: true },
        { key: 'directSendReport', title: t('report.DirectSendReport'), href: `${sitePrefix}Reports/DirectSendReport`, isShow: accountSettings && accountSettings?.IsDirectAccount === true && !userRoles?.HideRecipients },
        { key: 'directSendReportArchive', title: t('report.ArchiveDirectSendReport'), href: `${sitePrefix}Reports/DirectSendReport/Archive`, isShow: accountSettings && accountSettings?.IsDirectAccount === true && !userRoles?.HideRecipients },
        { title: t('master.OpenedClickedReport'), href: `${rootDomain}/EmailCampaignStatistics.aspx?fromreact=true`, isShow: true },
        { key: 'inboundMessages', title: t('master.responses'), href: `${sitePrefix}Reports/Inbound`, isShow: !userRoles?.HideRecipients },
      ],
    },
    { key: 'termOfUse', title: t('TermsOfUse.title'), href: `${sitePrefix}TermsOfUse`, iconSrc: '', isShow: false }
  ];
